import { TAction } from '../../../common/types';
import { TAudioWordItem, TAudioWordNativeItem, TLemmaResult } from '../../../common/rest/words/wordsRest';

export const WORDS_SET_DATA = 'WORDS/SET_DATA';
export const WORDS_SET_LOAD_FAILED = 'WORDS/SET_LOAD_FAILED';
export const WORDS_SET_GENERATE_FAILED = 'WORDS/SET_GENERATE_FAILED';
export const WORDS_SET_GENERATING = 'WORDS/SET_GENERATING';
export const WORDS_MERGE_LEMMAS = 'WORDS/MERGE_LEMMAS';
export const WORDS_LEMMAS_PENDING = 'WORDS/LEMMAS_PENDING';

export const WORDS_SET_NATIVE = 'WORDS/SET_NATIVE';

// The translation of exactly `words` (by reference) into langCode; items null while loading,
// [] after a failure — no tooltips and no retry until the list or the language changes.
export type TWordsNativeState = {
	langCode: string;
	words: TAudioWordItem[];
	items: TAudioWordNativeItem[] | null;
};

export type TAudioWordsState = {
	words: TAudioWordItem[];
	canRegenerate: boolean;
};

export interface IWordsState {
	byAudioId: Record<number, TAudioWordsState>;
	generating: Record<number, boolean>;
	// keyed by langCode, then word — lemmas are per language, not per recording
	lemmas: Record<string, Record<string, TLemmaResult>>;
	// in-flight lemma requests per langCode
	lemmasPending: Record<string, number>;
	// true when the last load for that audioId failed — shown instead of a spinner that never stops
	loadFailed: Record<number, boolean>;
	// the last generate failed — auto-generation stops retrying until the user asks again
	generateFailed: Record<number, boolean>;
	native: Record<number, TWordsNativeState>;
}

export interface ISetWordsNativeAction extends TAction<typeof WORDS_SET_NATIVE> {
	audioId: number;
	native: TWordsNativeState;
}

export interface ISetWordsDataAction extends TAction<typeof WORDS_SET_DATA> {
	audioId: number;
	data: TAudioWordsState;
}

export interface ISetWordsGeneratingAction extends TAction<typeof WORDS_SET_GENERATING> {
	audioId: number;
	generating: boolean;
}

export interface IMergeWordsLemmasAction extends TAction<typeof WORDS_MERGE_LEMMAS> {
	langCode: string;
	lemmas: Record<string, TLemmaResult>;
}

export interface IWordsLemmasPendingAction extends TAction<typeof WORDS_LEMMAS_PENDING> {
	langCode: string;
	delta: number;
}

export interface ISetWordsLoadFailedAction extends TAction<typeof WORDS_SET_LOAD_FAILED> {
	audioId: number;
	failed: boolean;
}

export interface ISetWordsGenerateFailedAction extends TAction<typeof WORDS_SET_GENERATE_FAILED> {
	audioId: number;
	failed: boolean;
}

export type TWordsActions =
	| ISetWordsGenerateFailedAction
	| ISetWordsLoadFailedAction
	| ISetWordsDataAction
	| ISetWordsGeneratingAction
	| IMergeWordsLemmasAction
	| IWordsLemmasPendingAction
	| ISetWordsNativeAction;
